/* eslint-disable import/no-anonymous-default-export */
// =============================================================================
// Lang for Vietnamese
// ==================================

export default {
    APP: {
        TITLE: "Quản lý sự cố",
        HOME: "Trang chủ",
    },

    LANGUAGE: {
        ENGLISH: "Tiếng anh",
        VIETNAMESE: "Tiếng việt",
    },

    COMMON: {
        OK: "Ok",
        NEW: "Mới",
        SAVE: "Lưu",
        EXIT: "Thoát",
        CLOSE: "Đóng",
        CANCEL: "Hủy",
        DELETE: "Xóa",
        FILTER: "Lọc",
        BACK: "Trở về",
        NEXT: "Tiếp tục",
        ADD_NEW: "Thêm mới",
        PREVIOUS: "Quay lại",
        EDIT: "Chỉnh sửa",
        SEARCH: "Tìm kiếm",
        UPDATE: "Cập nhật",
        CONFIRM: "Xác nhận",
        SELECTE: "Chọn",
        SELECTED: "Đã chọn",
        LANGUAGE: "Ngôn ngữ",
        TOTAL_COUNT: "Tổng số",
        VIEW_DETAIL: "Xem chi tiết",
        CLEAR_SEARCH: "Xóa tìm kiếm",
        NOTIFICATION: "Thông báo",
        NO_DATA: "Chưa có dữ liệu",
        NO_DATA_FOUND: "Không tìm thấy dữ liệu",
        ENTER_VALUE: "Nhập giá trị",
        SELECT_VALUE: "Chọn giá trị",
        DATETIME: "Thời gian",
        FROM: "Từ",
        TO: "Đến",
        CUSTOM: "Tùy chỉnh",
        STATUS: "Trạng thái",
        USERNAME: "Username",
        DEPARTMENT: "Phòng ban",
        STAFF: "Nhân sự",
    },

    MESSAGE: {
        NOT_FOUND: "Không tìm thấy dữ liệu!",
        TOKEN_EXPIRED: "Phiên đăng nhập đã hết hạn!",
        CONFIRM_LOGOUT: "Bạn có chắc chắn muốn đăng xuất?",
        NO_FUNCTION: "Xin lỗi! Hiện chưa có chức năng này!",
        REQUEST_TIMEOUT: "Hết hạn cho phiên đăng nhập! Vui lòng đăng nhập lại",
        NOT_PERMISSION: "Rất tiếc, bạn không có quyền truy cập vào tính năng này",
        NOT_DATA_PERMISSION: "Rất tiếc, bạn không có quyền thao tác trên dữ liệu này",
        USER_PROFILE_NOT_FOUND: "Không tìm thấy thông tin người dùng, vui lòng đăng nhập lại!",
        COMMON_ERROR: "Đã có phát sinh lỗi trong quá trình xử lý, vui lòng thử lại sau. Xin lỗi vì đã gây bất tiện.",
        IS_REQUIRED: "{0} là bắt buộc",
        CHAR_MAX_LENGTH: "Tối đa {0} ký tự",
    },

    PROFILE: {
        TITLE: "Thông tin cá nhân",
        SIGNATURE_PHOTO: "Hình ảnh chữ ký",
    },

    CHART: {
        YEAR: "Năm",
        MONTH: "Tháng",
        ALL: "Tất cả",
        OPENING: "Đang mở",
        BY_WEEK: "Theo tuần",
        BY_YEAR: "Theo năm",
        BY_MONTH: "Theo tháng",
        TARGET_OBJECT: "Đối tượng",
        INCIDENT_TYPE: "Loại sự cố",
        STATISTICS: "Số liệu thống kê",
        PROCESSED: "N.dùng t.xuyên",
        INCIDENT_STATUS: "Tình trạng xử lý",
        BY_DEPARTMENT: "Theo khoa/phòng",
        BY_HOSPITAL: "Theo BV phân loại",
        INCIDENT_TRACKING: "Theo dõi sự cố",
        SUMMARY_REPORTS_LEVELS: "Tổng hợp báo cáo các cấp",
        SUMMARY_UNEXPECTED_INCIDENT: "Tổng hợp báo cáo sự cố không mong muốn",
        PLEASE_ENTER_DATE_TIME: "Vui lòng chọn thời gian",
        PLEASE_ENTER_REPORT_LEVEL: "Vui lòng chọn cấp độ báo cáo",
        PLEASE_ENTER_TEMPLATE: "Vui lòng chọn mẫu báo cáo",
        TEMPLATE: "Mẫu báo cáo",
        TEMPLATE_DEFAULT: "Mặc định",
        TEMPLATE_SO_Y_TE: "Sở Y Tế",
        CONDITIONS_FOR_REPORTING: "Chọn điều kiện để tổng hợp báo cáo",
        ENTER_YEAR_FOR_REPORT: "Nhập năm muốn xuất báo cáo",
        SELECT_MONTH: "Chọn tháng",
    },

    REPORT: {
        REPORT: "Báo cáo",
        REPORT_CODE: "Mã BC",
        TYPE_REPORT: "Loại BC",
        LIST_REPORT: "Danh sách báo cáo",
        EXPORT_FILE: "Xuất file",
        OBLIGATION: "Bắt buộc",
        VOLUNTEER: "Tự nguyện",
        ANONYMOUS_REPORT: "Ẩn danh",
        REPORT_STATUS: "Tình trạng",
        SELECT_REPORT_STATUS: "Chọn tình trạng",
        TARGET_OBJECT: "Đối tượng",
        SELECT_TARGET_OBJECT: "Chọn đối tượng",
        SOURCE_REPORT: "Nguồn báo cáo",
        SELECT_SOURCE_REPORT: "Chọn nguồn báo cáo",
        HOSPITAL_CLASS: "Bệnh viện phân loại",
        SELECT_HOSPITAL_CLASS: "Chọn bệnh viện phân loại",
        SEARCH_TEXT: "Tìm kiếm theo tên người báo cáo, số bệnh án:",
        PLACEHOLDER_SEARCH_TEXT: "Nhập tên người báo cáo, số bệnh án",
        DEPARTMENT: "Khoa/phòng",
        SELECT_DEPARTMENT: "Chọn khoa/phòng",
        DEPARTMENT_INCIDENT: "Khoa/phòng nơi xảy ra sự cố",
        EVALUATE: "Đánh giá ban đầu",
        SELECT_EVALUATE: "Chọn đánh giá ban đầu",
        DETAIL_PLACE: "Vị trí cụ thể",
        ENTER_DETAIL_PLACE: "Nhập vị trí",
        SHORT_DESCRIPTION: "Mô tả ngắn gọn sự cố",
        ENTER_SHORT_DESCRIPTION: "Nhập mô tả",
        FIRST_SUGGESTED_SOLUTION: "Đề xuất giải pháp ban đầu",
        ENTER_FIRST_SUGGESTED_SOLUTION: "Nhập đề xuất",
        FIRST_TREATMENT: "Điều trị/Xử lý ban đầu đã thực hiện",
        REPORT_TYPE: "Hình thức báo cáo",
        CREATE_TIME_REPORT: "Ngày báo cáo",
        INCIDENT_TIME: "Thời điểm xảy ra sự cố",
        INCIDENT_OBJECT: "Đối tượng xảy ra sự cố",
        FOR_PATIENT: "Thông báo cho người bệnh",
        CLASSIFY_INCIDENT: "Phân loại ban đầu về sự cố",
        FOR_HOMIE: "Thông báo cho người nhà/ người giám hộ",
        FOR_DOCTOR: "Thông báo cho bác sĩ điều trị/người có kinh nghiệm",
        EVALUATE_INCIDENT: "Đánh giá ban đầu về mức độ ảnh hưởng của sự cố",
        MEDICAL_RECORD_RELATIVE: "Ghi nhận vào hồ sơ bệnh án/giấy tờ liên quan",
        PATIENT_INFORMATION: "Thông tin người bệnh",
        GENDER: "Giới tính",
        FULL_NAME: "Họ và tên",
        ENTER_FULL_NAME: "Nhập họ và tên",
        BIRTHDAY: "Ngày sinh",
        ENTER_BIRTHDAY: "Nhập ngày sinh",
        MEDICAL_RECORD_NO: "Số bệnh án",
        ENTER_MEDICAL_RECORD_NO: "Nhập số bệnh án",
        EMAIL: "Email",
        ENTER_EMAIL: "Nhập Email",
        PHONE_NUMBER: "Số điện thoại",
        ENTER_PHONE_NUMBER: "Nhập số điện thoại",
        DETECTOR: "Người phát hiện sự cố",
        ENTER_DETECTOR: "Nhập người phát hiện sự số",
        DETECTOR_TITLE: "Chức danh",
        ENTER_DETECTOR_TITLE: "Nhập chức danh",
        SELECT_DETECTOR_TITLE: "Chọn chức danh",
        WITNESSER: "Người chứng kiến",
        WITNESSER_1: "Người chứng kiến 1",
        WITNESSER_2: "Người chứng kiến 2",
        ENTER_WITNESSES_1: "Nhập Người chứng kiến 1",
        ENTER_WITNESSES_2: "Nhập Người chứng kiến 2",
        PHOTO_REPORT: "Hình ảnh liên quan",
        GENERAL_INFO: "Thông tin chung",
        DESCRIPTION: "Mô tả",
        CLASSIFY_BY_HOSPITAL: "Theo bệnh viện",
        NOTIFICATION: "Thông báo",
        REPORTER: "Người báo cáo",
        REPORTER_INFO: "Thông tin người báo cáo",
        CLOSE_REPORT: "Đóng báo cáo",
        CONFIRM_CLOSE_REPORT: "Bạn chắc chắn muốn đóng báo cáo này",
        CLOSE_REPORT_SUCCESS: "Đã đóng báo cáo thành công",
        REOPEN_REPORT: "Mở lại báo cáo",
        CONFIRM_REOPEN_REPORT: "Bạn chắc chắn muốn mở lại báo cáo này",
        REOPEN_REPORT_SUCCESS: "Đã mở lại báo cáo thành công",
        DELETE_REPORT: "Xóa báo cáo",
        CONFIRM_DELETE_REPORT: "Bạn chắc chắn muốn xóa báo cáo này",
        DELETE_REPORT_SUCCESS: "Đã xóa báo cáo thành công",
        CONFIRM_PRINT_REPORT: "Bạn chắc chắn muốn in báo cáo này",
        PRINT_REPORT_SUCCESS: "Đã in báo cáo thành công",
        PLEASE_ENTER_SHORT_DESCRIPTION: "Vui lòng nhập mô tả sự cố",
        INCIDENT_REPORT: "Báo cáo sự cố",
        UPDATE_REPORT: "Chỉnh sửa báo cáo",
        CREATE_REPORT_SUCCESS: "Tạo báo cáo sự cố thành công",
        UPDATE_REPORT_SUCCESS: "Cập nhật thông tin báo cáo sự cố thành công",
        GO_BACK_ACTION_MESSAGE: "Báo cáo chưa được lưu. Bạn có muốn lưu lại báo cáo hay không?",
        CONFIRM_EXPORT_FILE_REPORT: "Bạn chắc chắn muốn xuất file báo cáo",
        EXPORT_FILE_REPORT_SUCCESS: "Đã xóa xuất file báo cáo thành công",
        TAG: "Nhãn",
        TAG_NAME: "Tên nhãn",
        SELECT_TAG: "Chọn nhãn",
        ADD_NEW_TAG: "Thêm nhãn mới",
        ENTER_TAG_NAME: "Nhập tên nhãn",
        CREATE_TAG_SUCCESS: "Tạo nhãn mới thành công",
        PLEASE_ENTER_TAG_NAME: "Vui lòng nhập tên nhãn",

        REPEAT_ISSUE: "Sự cố lặp lại",
        OPEN_REPEAT_ISSUE: "Hiện sự cố lặp lại",
        REPORT_COUNT: "Số lượng sự cố lặp lại",
        REFERENCE_INCIDENT: "Sự cố gốc",
        SELECT_REFERENCE_INCIDENT: "Chọn sự cố gốc",
        REFERENCE_INCIDENT_LIST: "Danh sách sự cố gốc",
        PLEASE_SELECT_REFERENCE_INCIDENT: "Vui lòng chọn sự cố gốc",
        PRINT_REPORT: "In báo cáo",

        STATUS: {
            NEW: "Mới",
            ANALYZED: "Phân tích",
            PROCESSING: "Đang xử lý",
            PROCESSED: "Đã xử lý",
            CANCELLED: "Đã hủy",
            CLOSED: "Đã đóng",
        },
    },

    NOTIFICATION: {
        PUSH_NOTIFICATION: "Gửi thông báo",
        SEND: "Gửi",
    },

    MONITORING: {
        TITLE: "Theo dõi giải quyết sự cố",
        SEARCH_TEXT: "Tìm kiếm theo tên người báo cáo, người phụ trách, người phối hợp, số bệnh án:",
        PLACEHOLDER_SEARCH_TEXT: "Nhập tên người báo cáo, người phụ trách, người phối hợp, số bệnh án",
    },

    ANALYSIS: {
        ANALYSIS: "Phân tích",
        AI_ANALYSIS: "Phân tích AI",
        VIEW_ANALYSIS: "Xem phân tích",
        REPORT_ANALYSIS: "Phân tích báo cáo",
        GENERAL_INFORMATION: "Thông tin chung",
        INCIDENT_GROUP: "Nhóm sự cố",
        BY_HOSPITAL: "Theo bệnh viện",
        CAUSE: "Nguyên nhân",
        EXPERT_EVALUATION: "Đánh giá chuyên gia",
        SEVERITY_OFINJURY: "Mức độ tổn thương",
        INCIDENT_RESOLUTION_MONITORING: "Theo dõi giải quyết sự cố",
        IMAGE_ANALYSIS: "Hình ảnh phân tích",
        IMAGE_FISHBONE_DIAGRAM: "Sơ đồ xương cá",
        INCIDENT_TYPE_1: "Thực hiện quy trình kỹ thuật, thủ thuật chuyên môn",
        INCIDENT_TYPE_2: "Nhiễm khuẩn bệnh viện",
        INCIDENT_TYPE_3: "Thuốc và dịch truyền",
        INCIDENT_TYPE_4: "Máu và các chế phẩm máu",
        INCIDENT_TYPE_5: "Thiết bị y tế",
        INCIDENT_TYPE_6: "Hành vi",
        INCIDENT_TYPE_7: "Tai nạn đối với người bệnh",
        INCIDENT_TYPE_8: "Hạ tầng cơ sở",
        INCIDENT_TYPE_9: "Quản lý nguồn lực, tổ chức",
        INCIDENT_TYPE_10: "Hồ sơ, tài liệu, thủ tục hành chính",
        CAUSE_GROUP_1: "Nhân viên",
        CAUSE_GROUP_2: "Người bệnh",
        CAUSE_GROUP_3: "Môi trường làm việc",
        CAUSE_GROUP_4: "Tổ chức/dịch vụ",
        CAUSE_GROUP_5: "Yếu tố bên ngoài",
        SOURCE_REPORT: "Nguồn báo cáo",
        SELECT_SOURCE_REPORT: "Chọn nguồn báo cáo",
        HOSPITAL_CLASS: "Bệnh viện phân loại",
        SELECT_HOSPITAL_CLASS: "Chọn bệnh viện phân loại",
        INCIDENT_CAUSE: "Nguyên nhân gây sự cố",
        SELECT_INCIDENT_CAUSE: "Chọn nguyên nhân gây sự cố",
        ROOT_CAUSE: "Phân tích nguyên nhân gốc",
        DETECTION_RESULT: "Kết quả phát hiện",
        ENTERT_DETECTION_RESULT: "Nhập kết quả phát hiện",
        HAS_SUGGESTED_SOLUTION: "Đã thảo luận đưa khuyến cáo/Hướng xử lý với người báo cáo",
        FIT_WITH_RECOMMEND_RULE: "Phù hợp với các khuyến cáo chính thức được ban hành",
        DETAIL_RECOMMEN_DATION: "Ghi cụ thể khuyến cáo",
        ENTER_DETAIL_RECOMMEN_DATION: "Nhập mô tả (Không lặp lại các mô tả sự cố)",
        LEVEL_REPORT: "Cấp độ báo cáo",
        SELECT_LEVEL_REPORT: "Cấp độ báo cáo",
        ENTER_DESCRIPTION: "Nhập mô tả",
        DETAIL_DESCRIPTION: "Mô tả chi tiết sự cố",
        APPLIED_TREATMENT: "Điều trị/y lệnh đã được thực hiện",
        RECOVER_ACTION: "Hành động khắc phục sự cố",
        SUGGESTED_SOLUTION: "Đề xuất khuyến cáo phòng ngừa sự cố",
        ENTER_SUGGEST: "Nhập đề xuất",
        INCIDENT_TYPE: "Nhóm sự cố",
        SELECT_INCIDENT_TYPE: "Chọn nhóm sự cố",
        REPORT_STATUS: "Tình trạng",
        SELECT_REPORT_STATUS: "Chọn tình trạng",
        INCHARGED_STAFF: "Người phụ trách",
        SELECT_INCHARGED_STAFF: "Chọn người phụ trách",
        INCHARGED_STAFF_TITLE: "Chức danh người phụ trách",
        ENTER_INCHARGED_STAFF_TITLE: "Nhập chức danh người phụ trách",
        COORDINATED_STAFF: "Người phối hợp",
        SELECT_COORDINATED_STAFF: "Chọn người phối hợp",
        COORDINATED_STAFF_TITLE: "Chức danh người phối hợp",
        ENTER_COORDINATED_STAFF_TITLE: "Nhập chức danh người phối hợp",
        IMPLEMENT_PLAN: "Kế hoạch thực hiện",
        ENTER_IMPLEMENT_PLAN: "Nhập kế hoạch thực hiện",
        IMPLEMENT_RESULT: "Kết quả thực hiện",
        ENTER_IMPLEMENT_RESULT: "Nhập kết quả thực hiện",
        DUE_DATE: "Ngày cần hoàn thành",
        SCHEDULE_FINISH_DATE: "Ngày hoàn thành",
        SPECIFICALLY: "Cụ thể là",
        AFFECTED_TO_PATIENT: "Sự cố y khoa nghiêm trong (NC3)",
        SELECT_AFFECTED_TO_PATIENT: "Chọn sự cố y khoa nghiêm trong (NC3)",
        AFFECTED_TO_PATIENT_CAUSE: "Ảnh hưởng đối với tổ chức",
        SELECT_AFFECTED_TO_PATIENT_CAUSE: "Chọn ảnh hưởng đối với tổ chức",
        AFFECTED_TO_ORGANIZATION: "Ảnh hưởng đối với tổ chức",
        SELECT_AFFECTED_TO_ORGANIZATION: "Chọn ảnh hưởng đối với tổ chức",
        VALUE_ROOT_CAUSE_DEFAULT: `1. Môi trường (5S, Ánh sáng, An ninh,..): \n2. Thông tin (giao tiếp trục trặc, bảng chỉ dẫn,..): \n3. Quy trình quy định (Thiếu, chưa rõ, chưa đào tạo,..): \n4. Vật tư - thiết bị (Thiếu, hỏng, NV chưa biết dùng,..): \n5. Nhân viên (Phân công chưa rõ, thiếu động lực, phân bổ nguồn lực chưa tốt,..): \n6. Người bệnh (Chưa hợp tác, chưa hiểu nguy cơ,..): `,
        SUBMIT_SUCCESS: "Gửi phân tích báo cáo thành công!",
        PLEASE_ENTER_DETAILED_DESCRIPTION: "Vui lòng nhập mô tả chi tiết sự cố",
        GO_BACK_ACTION_MESSAGE: "Phân tích chưa được lưu. Bạn có muốn lưu lại phân tích hay không?",
    },

    ASSIGN: {
        ASSIGN: "Phân công",
        REPORT_STATUS: "Tình trạng",
        SELECT_REPORT_STATUS: "Chọn tình trạng",
        DUE_DATE: "Ngày cần hoàn thành",
        SCHEDULE_FINISH_DATE: "Ngày hoàn thành",
        IMPLEMENT_PLAN: "Kế hoạch thực hiện",
        ENTER_IMPLEMENT_PLAN: "Nhập kế hoạch thực hiện",
        INCHARGED_STAFF: "Người phụ trách",
        SELECT_INCHARGED_STAFF: "Chọn người phụ trách",
        INCHARGED_STAFF_TITLE: "Chức danh người phụ trách",
        ENTER_INCHARGED_STAFF_TITLE: "Nhập chức danh người phụ trách",
        COORDINATED_STAFF: "Người phối hợp",
        SELECT_COORDINATED_STAFF: "Chọn người phối hợp",
        COORDINATED_STAFF_TITLE: "Chức danh người phối hợp",
        ENTER_COORDINATED_STAFF_TITLE: "Nhập chức danh người phối hợp",
        SUBMIT_SUCCESS: "Phân công báo cáo thành công!",
        GO_BACK_ACTION_MESSAGE: "Phân công báo cáo chưa được lưu. Bạn có muốn lưu lại phân công báo cáo hay không?"
    },

    DATE_RANGE_PICKER: {
        YEAR: "Năm",
        DAY: "Ngày",
        WEEK: "Tuần",
        MONTH: "Tháng",

        TODAY: "Hôm nay",
        YESTERDAY: "Ngày hôm qua",
        THIS_WEEK: "Tuần này",
        LAST_WEEK: "Tuần trước đó",
        LAST_2_WEEK: "2 tuần trước",
        LAST_7_DAY: "7 ngày qua",
        LAST_30_DAY: "30 ngày qua",
        THIS_MONTH: "Tháng này",
        LAST_MONTH: "Tháng trước đó",
        LAST_2_MONTH: "2 tháng trước",
        THIS_YEAR: "Năm nay",
        LAST_YEAR: "Năm trước đó",
    },

    PROJECT_MANAGEMENT: {
        TITLE: "Quản lý dự án",
        PROJECT: "Dự án",
        DESCRIPTION: "Mô tả",
        ENTER_DESCRIPTION: "Nhập mô tả",
        PROJECT_NAME: "Tên dự án",
        ENTER_PROJECT_NAME: "Nhập tên dự án",
        PLEASE_ENTER_PROJECT_NAME: "Vui lòng nhập tên dự án",
        SELECT_PROJECT: "Chọn dự án",
        PLEASE_SELECT_PROJECT: "Vui lòng chọn dự án",
        ORGANIZATION: "Tổ chức",
        ORGANIZATION_NAME: "Tên tổ chức",
        ORGANIZATION_TYPE: "Loại tổ chức",
        SELECT_ORGANIZATION: "Chọn tổ chức",
        PLEASE_SELECT_ORGANIZATION: "Vui lòng chọn tổ chức",
        VIEW_LIST_ORGANIZATION: "Xem danh sách tổ chức",
        PLACEHOLDER_SEARCH_TEXT: "Tìm kiếm theo tên dự án",
        LIST_ORGANIZATION_OF_PROJECT: "Danh sách tổ chức thuộc dự án",
        PLACEHOLDER_SEARCH_TEXT_BY_ORGANIZATION: "Tìm kiếm theo tên tổ chức",
        CONFIRM_DELETE_PROJECT_ORGANIZATION: "Bạn chắc chắn muốn xóa?",
        DELETE_PROJECT_ORGANIZATION_SUCCESS: "Đã xóa thành công",
        ADD_NEW_PROJECT_ORGANIZATION: "Thêm tổ chức cho dự án: {0}",
        CREATE_PROJECT_ORGANIZATION_SUCCESS: "Thêm tổ chức cho dự án: {0} thành công",
        CONFIRM_DELETE_PROJECT: "Bạn chắc chắn muốn xóa dự án này?",
        DELETE_PROJECT_SUCCESS: "Đã xóa dự án thành công",
        CREATE_PROJECT_SUCCESS: "Thêm mới dự án thành công",
        UPDATE_PROJECT_SUCCESS: "Thêm chỉnh sửa thông tin dự án thành công",
    },

    PROJECT_MEMBER_MANAGEMENT: {
        TITLE: "Quản lý thành viên dự án",
        TITLE_CREATE: "Thêm thành viên dự án",
        MEMBER: "Thành viên",
        MEMBER_NAME: "Tên thành viên",
        SELECT_MEMBER: "Chọn thành viên",
        PLEASE_SELECT_MEMBER: "Vui lòng chọn thành viên",
        PLACEHOLDER_SEARCH_TEXT: "Tìm kiếm theo tên thành viên",
        USER_TITLE: "Chức danh",
        ENTER_USER_TITLE: "Nhập chức danh",
        ROLE: "Quyền hạn",
        SELECT_ROLE: "Chọn quyền hạn",
        FULL_NAME: "Họ và tên",
        ENTER_FULL_NAME: "Nhập họ và tên",
        PLEASE_ENTER_FULL_NAME: "Vui lòng nhập họ và tên",
        USER_NAME: "Tên đăng nhập",
        ENTER_USER_NAME: "Nhập tên đăng nhập",
        PLEASE_ENTER_USER_NAME: "Vui lòng nhập tên đăng nhập",
        EMAIL: "Email",
        ENTER_EMAIL: "Nhập Email",
        WRONG_FORMAT_EMAIL: "Email chưa đúng định dạng",
        PHONE_NUMBER: "Số điện thoại",
        ENTER_PHONE_NUMBER: "Nhập Số điện thoại",
        WRONG_FORMAT_PHONE_NUMBER: "Số điện thoại chưa đúng định dạng",
        PASSWORD: "Mật khẩu",
        ENTER_PASSWORD: "Nhập mật khẩu",
        MEMBER_NOT_ACCOUNT: "Thành viên chưa có tài khoản",
        MEMBER_ALREADY_ACCOUNT: "Thành viên đã có tài khoản",
        DELETE_PROJECT_MEMBER_SUCCESS: "Đã xóa thành viên thành công",
        CREATE_PROJECT_MEMBER_SUCCESS: "Thêm mới thành công thành công",
        CONFIRM_DELETE_PROJECT_MEMBER: "Bạn chắc chắn muốn xóa thành viên dự án này?",
    },

    SYNTHETIC: {
        TITLE: "Theo dõi báo cáo",
        PROJECT: "Dự án",
        SELECT_PROJECT: "Chọn dự án",
        ORGANIZATION_NAME: "Tên tổ chức",
        PLACEHOLDER_SEARCH_TEXT: "Nhập tên tổ chức",
        DURING_WEEK: "Trong tuần",
        DURING_YEAR: "Trong năm",
        FREQUENT_USERS: "Người dùng thường xuyên",
        CITY: "Tỉnh/ Thành phố",
    },

    SETTING: {
        TITLE: "Cấu hình hệ thống",
        CODE: "Mã",
        NAME: "Tên",
        TYPE: "Loại",
        GROUP: "Nhóm",
        GROUP_NAME: "Tên nhóm",
        ENTER_CODE: "Nhập mã",
        ENTER_NAME: "Nhập tên",
        PLEASE_ENTER_CODE: "Vui lòng nhập mã",
        PLEASE_ENTER_NAME: "Vui lòng nhập tên",
        CREATE_SUCCESS: "Thêm mới thành công",
        UPDATE_SUCCESS: "Cập nhật thành công",
        DEFAULT: "Mặc định",
        CUSTOM: "Tủy chỉnh",
        CONFIRM_DELETE_CODE_NAME: "Bạn chắc chắn muốn xóa thông tin này?",
        DELETE_CODE_NAME_SUCCESS: "Xóa thành công",
    },

    ORGANIZATION: {
        TITLE_MENU: "Tổ chức",
        TITLE_LIST_VIEW: "Danh sách tổ chức",
        TITLE_CREATE_VIEW: "Thêm mới tổ chức",
        TITLE_UPDATE_VIEW: "Cập nhật tổ chức",
        TITLE_DETAIL_VIEW: "Chi tiết tổ chức",

        CODE: "Mã tổ chức",
    },

    DEPARTMENT: {
        TITLE_MENU: "Phòng ban",
        TITLE_LIST_VIEW: "Danh sách phòng ban",
        TITLE_CREATE_VIEW: "Thêm mới phòng ban",
        TITLE_UPDATE_VIEW: "Cập nhật phòng ban",
        TITLE_DETAIL_VIEW: "Chi tiết phòng ban",
        
        CODE: "Mã phòng ban",
        IMPORT: "Import phòng ban",
    },

    USER: {
        TITLE_MENU: "Nhân sự",
        TITLE_LIST_VIEW: "Danh sách nhân sự",
        TITLE_CREATE_VIEW: "Thêm mới nhân sự",
        TITLE_UPDATE_VIEW: "Cập nhật nhân sự",
        TITLE_DETAIL_VIEW: "Chi tiết nhân sự",

        MERGE_USERNAME_PLACEHOLDER: "Nhập username",
        MERGE_USERNAME_EXPLAIN_1: "Bạn đang có tài khoản đăng nhập ở hệ thống cũ",
        MERGE_USERNAME_EXPLAIN_2: "Vui lòng nhập username QLSC (Quản lý sự cố) để hợp nhất tài khoản",
        MERGE_USERNAME_SUCCESS: "Hợp nhất tài khoản thành công",
        CANCLE_MERGING: "Không hợp nhất",

        IMPORT_USER: "Import nhân sự",
    },

    ZALO_BROWSER: {
        OPEN_BUTTON: "Mở bằng trình duyệt",
        HINT: "Bạn đang mở trang trong Zalo. Hãy mở bằng Safari hoặc Chrome để dùng đầy đủ tính năng.",
        CLOSE_BUTTON: "Đóng",
    },
};
